import React from "react";
import { useState } from "react";
import { devopsConsultingFaqs } from "../components/faqData.js";
import VoipSolContact from "../components/VoipSolContact.js";
import GetInTouch from "../components/GetInTouch.js";

const DevopsServices = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className=" flex flex-col items-center justify-center py-10 mt-20">
      <div className="flex flex-col md:flex-row justify-between items-center md:items-start px-4 md:px-16 py-8  min-h-screen">
        <div className="md:w-2/3 space-y-6 px-5">
          <h1 className="sm:text-4xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            DevOps Consulting Services
          </h1>
          <p className="text-gray-700 text-base lg:text-xl">
            Enhance collaboration, accelerate delivery, and ensure reliability
            in your development pipeline with expert DevOps practices.
          </p>
          <p className="text-gray-700 text-base lg:text-xl">
            Our DevOps consulting services empower businesses to establish a
            robust, continuous integration and continuous delivery (CI/CD)
            pipeline, enabling faster and more reliable software releases. We
            focus on automating and optimizing your development and deployment
            cycles to improve overall operational efficiency.
          </p>
          <p className="text-gray-700 text-base lg:text-xl">
            By leveraging cutting-edge tools and practices, we help bridge the
            gap between development and operations teams, ensuring seamless
            collaboration and alignment. With a focus on scalability,
            performance, and security, our solutions are designed to help
            businesses scale rapidly while maintaining high-quality standards.
          </p>
          <p className="text-gray-700 text-base lg:text-xl">
            We provide tailored DevOps strategies that align with your unique
            business needs, enabling you to optimize workflows, accelerate
            time-to-market, and reduce operational overhead.
          </p>
        </div>

        <VoipSolContact />
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Advantages of DevOps Consulting Services
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Our DevOps consulting services bridge gaps, streamline operations, and
          deliver the best possible solutions for your business needs.
        </p>
      </div>

      <div className=" p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ml-4">
          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon12.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Reduced development time and faster delivery
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon14.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Hassle-free deployment with automated pipelines
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon15.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Increased organizational performance and scalability
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon10.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Faster feature delivery with continuous updates
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon11.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Improved infrastructure and system reliability
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon13.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Minimized errors and streamlined operations
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <img
              src="\assets\icons\techIcons\icon16.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Automated workflows, reducing manual interventions
            </p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Key Features of Our DevOps Solutions
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          At Ayanshtech, we focus on fostering continuous collaboration and
          shared accountability between development and operations teams.
        </p>
      </div>

      <div className=" p-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/2 p-4">
            <img
              src=".\assets\images\headerSection\hireDevopsEng\img1.jpg"
              alt="Laptop with graph"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <h1 className="font-bold text-lg">End-to-End Implementation</h1>
                <p className="text-lg">
                  Agile-driven implementation to streamline and enhance your
                  business workflow.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <h1 className="font-bold text-lg">
                  Integration & Cloud Management
                </h1>
                <p className="text-lg">
                  Seamless integration of DevOps tools such as Jenkins,
                  TeamCity, and CircleCI for enhanced automation.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon19.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <h1 className="font-bold text-lg">Cloud-Native Architecture</h1>
                <p className="text-lg">
                  Leverage the power of cloud technologies to ensure
                  scalability, flexibility, and high availability.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <h1 className="font-bold text-lg">Strategy</h1>
                <p className="text-lg">
                  A strategic, phased approach to assess and modernize existing
                  IT infrastructure for improved efficiency.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon20.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <h1 className="font-bold text-lg">Testing & Monitoring</h1>
                <p className="text-lg">
                  Real-time testing and monitoring of systems to quickly detect
                  and address potential issues, using tools like Nagios and
                  Prometheus.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <h1 className="font-bold text-lg">
                  Collaboration & Communication
                </h1>
                <p className="text-lg">
                  Strengthening team collaboration through transparent processes
                  and streamlined communication.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <h1 className="font-bold text-lg">Managed DevOps Services</h1>
                <p className="text-lg">
                  Comprehensive support at every stage, from initial setup to
                  long-term maintenance, ensuring the best outcomes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" ">
        <div className="">
          <div className="text-center mt-10 mb-4 py-20">
            <h1 className="font-bold text-gray-800 mb-2 sm:text-3xl md:text-4xl lg:text-5xl">
              Our DevOps Solution Technology Stack
            </h1>
            <p className="text-gray-800 justify-center sm:text-base md:text-xl lg:text-xl px-5 ">
              We offer a comprehensive technology stack to address various
              real-time communications solutions, including VoIP Solutions and
              app development needs.
            </p>
          </div>
          <div className="flex justify-center">
            <div className="overflow-hidden max-w-7xl">
              <div className="flex animate-scroll-left gap-6">
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/anjularJs.png"
                    alt="Angular Js"
                    className="w-40 sm:w-40 md:w-48 lg:w-60 h-32 sm:h-32 md:h-40 lg:h-50 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/go.png"
                    alt="Go"
                    className="w-40 sm:w-40 md:w-48 lg:w-60 h-32 sm:h-32 md:h-40 lg:h-50 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/laravel.png"
                    alt="Laravel"
                    className="w-40 sm:w-40 md:w-48 lg:w-60 h-32 sm:h-32 md:h-40 lg:h-50 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/mern.png"
                    alt="Mern Stack"
                    className="w-40 sm:w-40 md:w-48 lg:w-60 h-32 sm:h-32 md:h-40 lg:h-50 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/php.png"
                    alt="PHP"
                    className="w-40 sm:w-40 md:w-48 lg:w-60 h-32 sm:h-32 md:h-40 lg:h-50 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/python.png"
                    alt="Python"
                    className="w-40 sm:w-40 md:w-48 lg:w-60 h-32 sm:h-32 md:h-40 lg:h-50 mx-auto object-cover"
                  />
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/techStack/reactJs.png"
                    alt="React JS"
                    className="w-40 sm:w-40 md:w-48 lg:w-60 h-32 sm:h-32 md:h-40 lg:h-50 mx-auto object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="justify-center items-center text-center py-10 space-y-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold">
          Why Partner with Ayanshtech
        </h2>
        <p className="sm:text-base md:text-md lg:text-lg text-gray-900 px-6 max-w-7xl">
          As a leading provider of DevOps services, we leverage cutting-edge
          technologies like Git, Docker, Jenkins, and Kubernetes to drive
          business transformation. At Ayanshtech, we implement innovative DevOps
          solutions that are not only agile but also secure and compliant. Our
          advanced DevOps services enable businesses to achieve faster product
          delivery, improved software quality, and enhanced team collaboration.
          We focus on bridging gaps and crafting tailored solutions that align
          with your goals.
          <br />
          <br />
          Our managed DevOps services offer highly efficient, cost-effective
          solutions with round-the-clock support and maintenance, ensuring an
          enhanced customer experience.
        </p>
      </div>

      <div className="max-w-3xl mx-auto p-6 py-20 w-full">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {devopsConsultingFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index ? "bg-blue-600 text-white px-5" : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <GetInTouch />
    </div>
  );
};

export default DevopsServices;
